import i18n from "@/language/i18n";
import REPORT_WIDGETS from "@/configuration/widgets/REPORT_WIDGETS";

const REPORT_MODULE_WINDOW_IDENTIFIER = Object.freeze({
    ABSENT_OVERVIEW_MODULE_WINDOW_ID: 'absentReport',
    ATTENDANCE_OVERVIEW_MODULE_WINDOW_ID: 'attendanceOverview',
    EMPLOYEE_REPORT_MODULE_WINDOW_ID: 'reports/monthly-hours',
    OCC_REPORT_MODULE_WINDOW_ID: 'reports/monthly-occ-group',
    ABSENT_REPORT_MODULE_WINDOW_ID: 'reports/absentevaluation',
    PROJECT_BUDGET_REPORT_MODULE_WINDOW_ID: 'reports/project-budget',
    ANNIVERSARY_VIEW_MODULE_WINDOW_ID: 'reports/anniversaryreport',
    STOCK_VIEW_MODULE_WINDOW_ID: 'reports/stock',
    COMMISSION_VIEW_MODULE_WINDOW_ID: 'reports/commission',
    SALES_STATISTICS_MODULE_WINDOW_ID: 'reports/sales-statistics',
    PROJECT_HOURS_MODULE_WINDOW_ID: 'reports/employee-hours-report',
    PROTOCOL_MODULE_WINDOW_ID: 'reports/protocol',
});

export { REPORT_MODULE_WINDOW_IDENTIFIER };

export default {
    REPORTS_GROUP_WRAPPER: {
        type: 'group',
        id: 'reports',
        label: i18n.t('ModuleRegistry.groups.reports.name.label'),
        children: [],
        icon: '$wPlanning',
        sidebarIcon: '$wNavReport'
    },
    CHILDREN: {
        ABSENT_OVERVIEW_MODULE: {
            type: 'module',
            id: 'absentOverview',
            windowIdentifierType: REPORT_MODULE_WINDOW_IDENTIFIER.ABSENT_OVERVIEW_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.reports.labels.absentOverview'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/absentReport',
        },
        ATTENDANCE_OVERVIEW_MODULE: {
            type: 'module',
            id: 'attendanceOverview',
            windowIdentifierType: REPORT_MODULE_WINDOW_IDENTIFIER.ATTENDANCE_OVERVIEW_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.reports.attendanceOverview.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/reports/attendanceoverview',
        },
        EMPLOYEE_REPORT_MODULE: {
            type: 'module',
            id: 'employeeReport',
            windowIdentifierType: REPORT_MODULE_WINDOW_IDENTIFIER.EMPLOYEE_REPORT_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.reports.labels.employeeReport'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/reports/monthly-hours',
            widgets: REPORT_WIDGETS.EMPLOYEE_REPORT_WIDGETS
        },
        OCC_REPORT_MODULE: {
            type: 'module',
            id: 'occGroupReport',
            windowIdentifierType: REPORT_MODULE_WINDOW_IDENTIFIER.OCC_REPORT_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.reports.labels.occReport'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/reports/monthly-occ-group',
            widgets: REPORT_WIDGETS.OCC_REPORT_WIDGETS
        },
        ABSENT_REPORT_MODULE: {
            type: 'module',
            id: 'absentReport',
            windowIdentifierType: REPORT_MODULE_WINDOW_IDENTIFIER.ABSENT_REPORT_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.reports.absentReport.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/reports/absentevaluation',
            widgets: REPORT_WIDGETS.ABSENT_REPORT_WIDGETS
        },
        PROJECT_BUDGET_REPORT_MODULE: {
            type: 'module',
            id: 'projectBudgetReport',
            label: i18n.t('ModuleRegistry.groups.reports.labels.projectBudgetReport'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/reports/project-budget',
            widgets: REPORT_WIDGETS.PROJECT_BUDGET_REPORT_WIDGETS
        },
        ANNIVERSARY_VIEW_MODULE: {
            type: 'module',
            id: 'anniversary',
            windowIdentifierType: REPORT_MODULE_WINDOW_IDENTIFIER.ANNIVERSARY_VIEW_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.reports.anniversaryView.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/reports/anniversaryreport',
            widgets: REPORT_WIDGETS.ANNIVERSARY_REPORT_WIDGETS
        },
        STOCK_VIEW_MODULE: {
            type: 'module',
            id: 'stockReport',
            windowIdentifierType: REPORT_MODULE_WINDOW_IDENTIFIER.STOCK_VIEW_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.reports.stockView.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/reports/stock',
            widgets: REPORT_WIDGETS.REPORT_STOCK_WIDGETS
        },
        COMMISSION_VIEW_MODULE: {
            type: 'module',
            id: 'commissionReport',
            windowIdentifierType: REPORT_MODULE_WINDOW_IDENTIFIER.COMMISSION_VIEW_MODULE_WINDOW_ID,
            label: i18n.t("Commissions.words.commissions"),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/reports/commissions',
        },        
        SALES_STATISTICS_MODULE: {
            type: 'module',
            id: 'salesStatisticsReport',
            windowIdentifierType: REPORT_MODULE_WINDOW_IDENTIFIER.SALES_STATISTICS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.reports.salesStatisticsReport.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/reports/sales-statistics',
            widgets: REPORT_WIDGETS.SALE_STATISTICS_REPORT
        },
        PROJECT_HOURS_MODULE: {
            type: 'module',
            id: 'projecthoursReport',
            windowIdentifierType: REPORT_MODULE_WINDOW_IDENTIFIER.PROJECT_HOURS_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.reports.projecthoursReport.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/reports/employee-hours-report',
        },
        PROTOCOL_MODULE: {
            type: 'module',
            id: 'protocolReport',
            windowIdentifierType: REPORT_MODULE_WINDOW_IDENTIFIER.PROTOCOL_MODULE_WINDOW_ID,
            label: i18n.t('ModuleRegistry.groups.reports.protocols.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/reports/protocols',
        },
        BALANCE_MODULE: {
            type: 'module',
            id: 'balanceReport',
            label: i18n.t('Reports.Balance.words.balanceReport'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/reports/balance-report',
        },
        BALANCE_CHANGE_MODULE: {
            type: 'module',
            id: 'balancechange',
            label: i18n.t('Reports.BalanceChange.words.balanceChange'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/reports/balancechange',
        },
        WEEKEND_OFFICIAL_HOLIDAY_REPORT_MODULE: {
            type: 'module',
            id: 'weekendOfficialHolidayReport',
            label: i18n.t('ModuleRegistry.groups.reports.weekendOfficialHoliday.label'),
            navigationImg: require('@/assets/navigation/items/timetracking-item.png'),
            routerLink: '/reports/weekend-official-holiday',
        }
    }
}
